export const checkExpressAction= (data) => { 
  return {
     type: data.type,
     data:data.data
  }
}